<template>
  <div class="progress-module">
    <div class="module-title">生产进度</div>
    <div class="progress-content">
      <div class="progress-bar-container">
        <div class="progress-bar">
          <div 
            class="progress-fill" 
            :style="{ width: progressPercent + '%' }"
          ></div>
        </div>
        <div class="progress-text">{{ progressPercent }}%</div>
      </div>
      
      <div class="progress-info">
        <div class="info-row">
          <span class="label">已采集:</span>
          <span class="value highlight">
            <count-to 
              :start-val="0" 
              :end-val="collectedQuantity" 
              :duration="1000"
              :decimals="0"
              separator=","
            />
            {{ displayUnit }}
          </span>
        </div>
        <div class="info-row">
          <span class="label">计划数量:</span>
          <span class="value">{{ formatNumber(planQuantity) }} {{ displayUnit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  name: 'ProgressModule',
  components: {
    CountTo
  },
  props: {
    planQuantity: {
      type: Number,
      default: 0
    },
    collectedQuantity: {
      type: Number,
      default: 0
    },
    planUnit: {
      type: String,
      default: ''
    },
    planUnitName: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 优先使用单位名称，如果没有则使用单位编码
    displayUnit() {
      return this.planUnitName || this.planUnit || ''
    },
    progressPercent() {
      if (this.planQuantity === 0) return 0
      const percent = (this.collectedQuantity / this.planQuantity) * 100
      return Math.min(Math.round(percent), 100)
    }
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-module {
  background: rgba(0, 255, 255, 0.08);
  border: 2px solid rgba(0, 255, 255, 0.4);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 25px rgba(0, 255, 255, 0.2);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.module-title {
  font-size: 18px;
  color: #00ffff;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
  text-align: center;
  letter-spacing: 2px;
}

.progress-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  justify-content: center;
}

.progress-bar-container {
  position: relative;
}

.progress-bar {
  height: 35px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(0, 255, 255, 0.3);
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #00ffff 0%, #00ccff 50%, #0099ff 100%);
  border-radius: 18px;
  transition: width 1s ease-out;
  box-shadow: 0 0 25px rgba(0, 255, 255, 0.8);
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    animation: flow 2s infinite;
  }
}

@keyframes flow {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1), 0 0 5px rgba(0, 0, 0, 0.8);
}

.progress-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  
  .label {
    color: rgba(255, 255, 255, 0.7);
    font-size: 15px;
    font-weight: 500;
  }
  
  .value {
    color: #ffffff;
    font-size: 17px;
    font-weight: 600;
    
    &.highlight {
      color: #00ffff;
      text-shadow: 0 0 12px rgba(0, 255, 255, 0.6);
      font-size: 18px;
    }
  }
}
</style>
